export default class AutorInput {
    constructor () {
      this.id = null
      this.nome = null
      this.foto = null
      this.email = null
      this.contato = null
    }
  }